import { create } from 'zustand';

interface VideoState {
  videoUrl: string | null;
  currentFrame: number;
  fps: number;
  duration: number;
  currentTime: number;
  setVideoUrl: (url: string | null) => void;
  setCurrentFrame: (frame: number) => void;
  setFps: (fps: number) => void;
  setDuration: (duration: number) => void;
  setCurrentTime: (time: number) => void;
  reset: () => void;
}

const DEFAULT_FPS = 240;

export const useVideoStore = create<VideoState>((set, get) => ({
  videoUrl: null,
  currentFrame: 0,
  fps: DEFAULT_FPS,
  duration: 0,
  currentTime: 0,
  setVideoUrl: (url) => {
    set((state) => {
      if (state.videoUrl) {
        URL.revokeObjectURL(state.videoUrl);
      }
      return { 
        videoUrl: url,
        currentFrame: 0,
        currentTime: 0,
        duration: 0
      };
    });
  },
  setCurrentFrame: (frame) => {
    const fps = get().fps;
    const time = frame / fps;
    set({ 
      currentFrame: frame,
      currentTime: time
    });
  },
  setFps: (fps) => {
    // Ensure FPS is one of the supported values
    const validFps = [60, 120, 240].includes(fps) ? fps : DEFAULT_FPS;
    set({ fps: validFps });
  },
  setDuration: (duration) => set({ duration }),
  setCurrentTime: (time) => {
    const fps = get().fps;
    const frame = Math.floor(time * fps);
    set({ 
      currentTime: time,
      currentFrame: frame
    });
  },
  reset: () => {
    set((state) => {
      if (state.videoUrl) {
        URL.revokeObjectURL(state.videoUrl);
      }
      return {
        videoUrl: null,
        currentFrame: 0,
        currentTime: 0,
        fps: DEFAULT_FPS,
        duration: 0,
      };
    });
  },
}));